import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"search\"><path fill=\"currentColor\" d=\"M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z\" /><path d=\"M2 8c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6zm17.707 10.293l-5.395-5.396A7.944 7.944 0 0 0 16 8c0-4.41-3.59-8-8-8S0 3.59 0 8s3.59 8 8 8a7.954 7.954 0 0 0 4.897-1.688l5.396 5.395a.996.996 0 0 0 1.414 0 1 1 0 0 0 0-1.414z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol